// extracted by mini-css-extract-plugin
var _1 = "F83Cfo_U";
var _2 = "w1n91rnV";
export { _1 as "link", _2 as "skiplinks" }
